import gql from "graphql-tag";
import { FileCategories_fileCategories } from "@/models/queries/types/FileCategories";

export const FILE_CATEGORIES_QUERY = gql`
  query FileCategories {
    fileCategories {
      id
      name
      allowedFileTypes
    }
  }
`;

export type FileCategory = FileCategories_fileCategories;
